import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import HowItWorks from "@/components/HowItWorks";
import Services from "@/components/Services";
import Clients from "@/components/Clients";
import Team from "@/components/Team";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const Index = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Siatech Brasil",
    "description": "Especialistas em AFRMM com tecnologia proprietária e expertise real. Transformamos o processo de creditamento para Empresas Brasileiras de Navegação.",
    "url": "https://siatechbrasil.com.br",
    "logo": "https://siatechbrasil.com.br/logo-preto.svg",
    "image": "https://siatechbrasil.com.br/logo-preto.svg",
    "telephone": "+55 (91) 98157-3458",
    "email": "contato@siatechbrasil.com.br",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Belém",
      "addressLocality": "Belém",
      "addressRegion": "PA",
      "addressCountry": "BR"
    },
    "openingHours": "Mo-Fr 08:00-18:00",
    "serviceType": "Consultoria em AFRMM e Creditamento para EBNs",
    "areaServed": ["Brasil", "PA", "AM"],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />

      <div className="min-h-screen" role="main">
        <Header />
        <main>
          <Hero />
          <Problem />
          <Solution />
          <HowItWorks />
          <Services />
          <Clients />
          <Team />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default Index;
